module.exports = __webpack_public_path__ + "static/media/SP_S_Jacquard_Meda_Ind.Blue_Peri.18d3a5bb.png";